// extracted by mini-css-extract-plugin
export default {"main":"IndexPage_main__0E0rV","buttons":"IndexPage_buttons__q-hUA"};